export default "__VITE_ASSET__56007294__"